import React from "react";
import "../home/main.css";
class Toast extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  render() {
    let classes = `toast ${this.props.level} `;
    classes += this.state.visible ? "visible" : "";

    return (
      <div className={classes}>
        <p>{this.props.message}</p>
      </div>
    );
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.visible !== prevState.visible) {
      return { visible: nextProps.visible };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible !== prevState.visible) {
      this.setState({ visible: prevProps.visible });
    }
  }
}

export default Toast;
